module.exports = __webpack_public_path__ + "static/img/anthony-collins.de4a52c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logos/home-page-logos/anthony-collins.png
// module id = 3J/s
// module chunks = 0